import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";

import { Env } from "../common/constants/env";

const posthogKey = Env.POSTHOG_KEY;
const posthogHost = Env.POSTHOG_HOST;
const reverseProxyTarget = Env.REVERSE_PROXY_TARGET;

const posthogApiHost = reverseProxyTarget || posthogHost;

if (posthogKey && posthogApiHost) {
  posthog.init(posthogKey, {
    api_host: posthogApiHost,
    ui_host: posthogHost || undefined,
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: false,
  });
}

export { posthog, PostHogProvider };
